module.exports = __webpack_public_path__ + "img/irrigation-control-2.f0fbb5ca.webp";